import React from "react";
import { toast } from "react-toastify";

const DeepSeekTopicStats = ({ stats, onSelectUser, t }) => {
    return (
        <>
            {/* Top Topics and Categories Distribution */}
            <div className="row g-4 mb-4 text-right" style={{ direction: 'rtl' }}>
                <div className="col-md-6 col-12">
                    <div className="deepseek-stats-section-title">
                        <i className="fal fa-comments ml-2 text-primary" style={{ fontSize: '18px' }}></i>
                        {t('Pages.DeepSeekAdmin.topTopicsTitle') || "أكثر المواضيع تداولاً ومحادثة"}
                    </div>
                    <div className="deepseek-distribution-card">
                        {stats?.TopTopics && stats.TopTopics.length > 0 ? (
                            <div className="deepseek-distribution-list">
                                {stats.TopTopics.map((topic, idx) => {
                                    const maxCount = stats.TopTopics[0].ConversationCount || 1;
                                    const pct = ((topic.ConversationCount / maxCount) * 100).toFixed(0);
                                    return (
                                        <div key={idx} className="deepseek-dist-item mb-3">
                                            <div className="d-flex justify-content-between mb-1 small font-weight-bold">
                                                <span className="text-dark">{topic.TopicName}</span>
                                                <span className="text-primary">{topic.ConversationCount} {t('Pages.DeepSeekAdmin.conversation') || "محادثة"}</span>
                                            </div>
                                            <div className="progress" style={{ height: '8px', borderRadius: '4px', backgroundColor: '#f1f5f9' }}>
                                                <div
                                                    className="progress-bar animate__animated animate__fadeInLeft"
                                                    role="progressbar"
                                                    style={{ width: `${pct}%`, backgroundColor: '#92278f', borderRadius: '4px' }}
                                                    aria-valuenow={pct}
                                                    aria-valuemin="0"
                                                    aria-valuemax="100"
                                                ></div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="text-center py-4 text-muted small">
                                {t('Pages.DeepSeekAdmin.noData') || "لا توجد مواضيع مسجلة"}
                            </div>
                        )}
                    </div>
                </div>

                <div className="col-md-6 col-12">
                    <div className="deepseek-stats-section-title">
                        <i className="fal fa-th-list ml-2 text-success" style={{ fontSize: '18px' }}></i>
                        {t('Pages.DeepSeekAdmin.topCategoriesTitle') || "أكثر تصنيفات المواضيع استخداماً"}
                    </div>
                    <div className="deepseek-distribution-card">
                        {stats?.TopCategories && stats.TopCategories.length > 0 ? (
                            <div className="deepseek-distribution-list">
                                {stats.TopCategories.map((cat, idx) => {
                                    const maxCount = stats.TopCategories[0].ConversationCount || 1;
                                    const pct = ((cat.ConversationCount / maxCount) * 100).toFixed(0);
                                    return (
                                        <div key={idx} className="deepseek-dist-item mb-3">
                                            <div className="d-flex justify-content-between mb-1 small font-weight-bold">
                                                <span className="text-dark">{cat.CategoryName}</span>
                                                <span className="text-success">{cat.ConversationCount} {t('Pages.DeepSeekAdmin.conversation') || "محادثة"}</span>
                                            </div>
                                            <div className="progress" style={{ height: '8px', borderRadius: '4px', backgroundColor: '#f1f5f9' }}>
                                                <div
                                                    className="progress-bar animate__animated animate__fadeInLeft"
                                                    role="progressbar"
                                                    style={{ width: `${pct}%`, backgroundColor: '#22c55e', borderRadius: '4px' }}
                                                    aria-valuenow={pct}
                                                    aria-valuemin="0"
                                                    aria-valuemax="100"
                                                ></div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="text-center py-4 text-muted small">
                                {t('Pages.DeepSeekAdmin.noData') || "لا توجد تصنيفات مسجلة"}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Costly Chats and Pure AI Topics */}
            <div className="row g-4 mb-4 text-right" style={{ direction: 'rtl' }}>
                <div className="col-md-6 col-12">
                    <div className="deepseek-stats-section-title">
                        <i className="fal fa-brain ml-2 text-info" style={{ fontSize: '18px' }}></i>
                        {t('Pages.DeepSeekAdmin.noRelativeTextTitle') || "المواضيع الأكثر حديثاً بدون نصوص مرتبطة"}
                    </div>
                    <div className="deepseek-distribution-card">
                        {stats?.NoRelativeTextByTopic && stats.NoRelativeTextByTopic.length > 0 ? (
                            <div className="deepseek-distribution-list">
                                {stats.NoRelativeTextByTopic.map((topic, idx) => {
                                    const maxCount = stats.NoRelativeTextByTopic[0].ConversationCount || 1;
                                    const pct = ((topic.ConversationCount / maxCount) * 100).toFixed(0);
                                    return (
                                        <div key={idx} className="deepseek-dist-item mb-3">
                                            <div className="d-flex justify-content-between mb-1 small font-weight-bold">
                                                <span className="text-dark">{topic.TopicName}</span>
                                                <span className="text-info">{topic.ConversationCount} {t('Pages.DeepSeekAdmin.conversation') || "محادثة"}</span>
                                            </div>
                                            <div className="progress" style={{ height: '8px', borderRadius: '4px', backgroundColor: '#f1f5f9' }}>
                                                <div
                                                    className="progress-bar animate__animated animate__fadeInLeft"
                                                    role="progressbar"
                                                    style={{ width: `${pct}%`, backgroundColor: '#0ea5e9', borderRadius: '4px' }}
                                                    aria-valuenow={pct}
                                                    aria-valuemin="0"
                                                    aria-valuemax="100"
                                                ></div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="text-center py-4 text-muted small">
                                {t('Pages.DeepSeekAdmin.noData') || "لا توجد مواضيع مسجلة"}
                            </div>
                        )}
                    </div>
                </div>

                <div className="col-md-6 col-12">
                    <div className="deepseek-stats-section-title">
                        <i className="fal fa-file-invoice-dollar ml-2 text-danger" style={{ fontSize: '18px' }}></i>
                        {t('Pages.DeepSeekAdmin.mostCostlyChatsTitle') || "أكثر المحادثات تكلفة خلال الشهر الحالي"}
                    </div>
                    <div className="deepseek-distribution-card p-3">
                        {stats?.MostCostlyConversations && stats.MostCostlyConversations.length > 0 ? (
                            <div className="table-responsive">
                                <table className="table table-hover mb-0" style={{ fontSize: '12px' }}>
                                    <thead>
                                        <tr>
                                            <th>{t('Pages.DeepSeekAdmin.user') || "المستخدم"}</th>
                                            <th>{t('Pages.DeepSeekAdmin.topicNameLabel') || "الموضوع"}</th>
                                            <th>{t('Pages.DeepSeekAdmin.price') || "التكلفة"}</th>
                                            <th>{t('Pages.DeepSeekAdmin.actions') || "خيارات"}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {stats.MostCostlyConversations.map((conv, idx) => (
                                            <tr key={idx}>
                                                <td className="font-weight-bold text-dark">
                                                    {conv.FullName}
                                                </td>
                                                <td>{conv.TopicName}</td>
                                                <td className="text-danger font-weight-bold">${conv.TotlaPrice.toFixed(4)}</td>
                                                <td>
                                                    {conv.UserId && onSelectUser ? (
                                                        <div className="d-flex align-items-center gap-2">
                                                            <button
                                                                className="btn btn-xs btn-outline-primary"
                                                                onClick={() => onSelectUser({ Id: conv.UserId, Name: conv.FullName, Username: conv.Username })}
                                                                style={{ fontSize: '10px', padding: '2px 6px' }}
                                                            >
                                                                {t('Pages.DeepSeekAdmin.viewUserChats') || "عرض السجل"}
                                                            </button>
                                                            {conv.ConversationId && (
                                                                <button
                                                                    className="btn btn-xs btn-outline-secondary ml-1"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        const url = `${window.location.origin}/ControlPanel/DeepSeek/${conv.ConversationId}`;
                                                                        navigator.clipboard.writeText(url).then(() => {
                                                                            toast.success(t('Pages.DeepSeekAdmin.linkCopied') || "تم نسخ رابط المحادثة بنجاح!");
                                                                        });
                                                                    }}
                                                                    style={{ fontSize: '10px', padding: '2px 6px', width: 'auto' }}
                                                                    title={t('Pages.DeepSeekAdmin.copyLink') || "نسخ الرابط المباشر"}
                                                                >
                                                                    <i className="fal fa-link"></i>
                                                                </button>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <span className="text-muted small">-</span>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="text-center py-4 text-muted small">
                                {t('Pages.DeepSeekAdmin.noCostlyChats') || "لا توجد محادثات ذات تكلفة مسجلة هذا الشهر."}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default DeepSeekTopicStats;
